import "./AccountFlyoutProfile.scss";

import * as React from "react";
import { BusinessAccount, BusinessAccountResponse } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import { AccountFlyoutIcon } from "./AccountFlyoutIcon";

type Props = {
    businessAccount: BusinessAccountResponse;
    isMenuVisible: boolean;
    setMenuVisible: (isMenusVisible: boolean) => void;
};

export function AccountFlyoutProfile(props: Props) {
    const personName: string = props.businessAccount.person.name;
    const activeAccount: BusinessAccount | undefined | null = props.businessAccount.getActiveAccount();

    const toggleDropdown = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        props.setMenuVisible(!props.isMenuVisible);
        if (props.isMenuVisible) {
            window.document.body.classList.remove("disable-scrolling");
        } else {
            window.document.body.classList.add("disable-scrolling");
        }
    };

    return (
        <div className="account-flyout-profile" onClick={(event) => toggleDropdown(event)}>
            <div className="user-details">
                <div className="username">
                    <span>{personName}</span>
                </div>
                <div className="user-business">
                    <span>{activeAccount?.corporateName}</span>
                </div>
            </div>
            <AccountFlyoutIcon isMenuVisible={props.isMenuVisible} />
        </div>
    );
}
